export enum Direction {
  West = 'west',
  East = 'east',
  North = 'north',
  South = 'south',
}
